import React from "react";
import { useFriendshipModel } from "../friendshipModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";

const searchFields = [
    {
        type: SearchTypeEnum.Input,
        placeholder: "网站名称",
        fieldName: "siteName"
    },
    {
        type: SearchTypeEnum.Datepicker,
        fieldName: "createTime",
        placeholder: "创建时间",
        format: "YYYY-MM-DD",
    },
]

export function PageHeader() {
    const {
        searchParam,
        initPgCfg,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useFriendshipModel();

    return (
        <YhPageHeader
            title="友情链接"
            justify="end"
            triggerSearch={true}
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            // handleSearch={loadData}
            handleSearch={(params) => loadData(initPgCfg, {...searchParam,...params})}
            handleReset={resetSearchParam}
        />
    );
}